'use client';
import Image from 'next/image';
import Link from 'next/link';
import { useParams } from 'next/navigation';

interface ShibLogoProps {
  className?: string;
}

const ShibLogo = ({ className }: ShibLogoProps) => {
  const { locale } = useParams();
  return (
    <Link href={`/${locale}`} className="flex items-center">
      <Image
        width={175.15}
        height={48}
        src="/logos/shib_logo.png"
        className={`${className}`}
        alt="Shibthemetaverse.io Logo"
      />
    </Link>
  );
};

export default ShibLogo;
